import { Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import React from "react";

const MessageQueuesPermissions = (props) => {

  const { role } = props;

  return (
    <>
      <Card className="bg-gray">
        <Card.Body>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Master Message Queue
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Master Message Table
                  </span>
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View Messages In Queue
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Select "Identifier" Hyperlink
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Col style={{ display: "flex", justifyContent: "center" }}>
                <Card style={{ width: "500px", marginTop: "75px" }}>
                  <Row style={{ marginTop: "10px", marginBottom: "10px" }}>
                    <Col className="offset-1 textSmallFontBig">
                      Permissions:
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "10px" }}>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Can Edit</div>
                    </Col>
                    <Col>
                      <div>(Visible and can perform screen action)</div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Can Read</div>
                    </Col>
                    <Col>
                      <div>(Visible on Screen but Cannot Edit)</div>
                    </Col>
                  </Row>
                  <Row style={{ marginBottom: "10px" }}>
                    <Col sm={3} className="offset-1 textSmallFontBig">
                      <div>Cannot Read</div>
                    </Col>
                    <Col>
                      <div>(Not visible on Screen)</div>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Master Message Queue (Message Details)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    QA Flags Tab (Apply Button)
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Error Message Queue
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Error Message Table
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View Messages In Queue
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Reprocess Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Rule Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Select "Identifier" Hyperlink
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Error Messages Queue (Message Details)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Reprocess Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Discard Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Rule Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    QA Flags Tab (Apply Button)
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Unknown Facility Queue
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "35px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Unknown Facility Table
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View Messages In Queue
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Reprocess Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Discard Message Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Sending Facility Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row style={{ marginBottom: "100px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontBig generalFont">
                    Unknown Facility Queue (Message Details)
                  </span>
                </Col>
                <Col></Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Update Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Reprocess Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Discard Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value={role.roleName === "Informatics Admin" ? "Can Edit" : "Cannot Read"}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Add New Rule Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    QA Flags Tab (Apply Button)
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
          <Row>
            <Col sm={4}>
              <span className="textSmallFontBig generalFont">
                Discard Queue
              </span>
            </Col>
            <Col>
              <span className="textSmallFontBig generalFont">Permissions</span>
            </Col>
          </Row>
          <hr className="divider" />
          <Row style={{ marginBottom: "25px" }}>
            <Col>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    View Messages in Queue
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Read"
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "25px" }}>
                <Col sm={8}>
                  <span className="textSmallFontSm generalFont">
                    Restore Button
                  </span>
                </Col>
                <Col>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    disabled
                    value="Can Edit"
                  />
                </Col>
              </Row>
            </Col>
            <Col></Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default MessageQueuesPermissions;
